export default {
  id: 'location.sellThroughRate',
  name: 'location.sellThroughRate',
  displayName: 'Sell Through Rate',
  valueType: 'string',
  objectType: 'location',
  blueprint: {},
  get: obj => obj?.data?.company?.id
};